<template>
  <ButtonPopover
    v-model="isOpen"
    class="search-form-select"
    icon="both"
    size="medium"
    placement="bottom-left"
    trigger="click"
    :disabled="disabled"
    @click.native="$emit('close-input-dropdown')"
  >
    <template #left-icon>
      <component
        :is="selectedOption.icon"
        v-if="selectedOption.icon"
        class="icon"
      />
    </template>
    <template #label>
      <span class="label text-small">
        {{ selectedOption && selectedOption.label }}
      </span>
    </template>
    <template #right-icon>
      <UilAngleDown />
    </template>

    <ul class="text-small">
      <li
        v-for="(option, index) in options"
        :key="`options-list-item-${index}`"
        class="options-list-item"
        :class="{ active: selectedOption.name === option.name, }"
      >
        <button
          type="button"
          class="options-list-item-btn"
          @click="selectOption(option)"
        >
          <UilAngleRightB v-if="selectedOption.name === option.name" />
          {{ option.label }}
        </button>
      </li>
    </ul>
  </ButtonPopover>
</template>

<script>
import ButtonPopover from "../../components/buttons/ButtonPopover.vue";

import { UilAngleDown, UilAngleRightB } from "@iconscout/vue-unicons";

/**
 * Affiche un dropdown pour sélectionner une option parmi une liste donnée.
 */
export default {
  name: "SearchFormSelect",
  components: {
    ButtonPopover,
    UilAngleDown,
    UilAngleRightB,
  },
  props: {
    /**
     * Option sélectionnée.
     */
    selectedOption: {
      type: Object,
      default: null,
    },
    /**
     * Options à afficher.
     */
    options: {
      type: Array,
      required: true,
    },
    /**
     * Si on désactive la sélection.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /**
     * Déclenché lorsqu'une option est selectionnée.
     * @param {Object} option Infos relatives à l'option.
     */
    "select-option",
  ],
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    /**
     * Sélectionne une option et ferme le dropdown.
     * @param {Object} option Option sélectionnée.
     */
    selectOption(option) {
      this.$emit("select", option);
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss">
@use "../../assets/styles/components/search/search_form_select.scss";
@use "../../assets/styles/components/forms/options_list.scss";
</style>
